import { Link } from "@fluentui/react";
import { FC } from "react";
import styled from "styled-components";
import { Icon as IconProps } from "@cayo/shared/api/types/cayo-graph";
import { defaultLabelStyle } from "@cayo/shared/components/CommonLayout";
import Icon from "../../Graphics/Icon";
import { IActionPromise } from "../../LegacyDetailsList/cell-renderers";

type IconAnnotationGetter = (type: string) => IconProps;

const LinkedObject: FC<{
  objectName: string;
  objectType: string;
  linkType: string;
  originalObjectPath?: string;
  objectPath?: string;
  onItemClicked?: IActionPromise;
  getIconAnnotation?: IconAnnotationGetter;
}> = ({
  objectType,
  linkType,
  originalObjectPath,
  objectPath,
  objectName,
  onItemClicked,
  getIconAnnotation,
}) => {
  const path = originalObjectPath ?? objectPath;

  return (
    <LinkedObjectContainer>
      <Icon iconName={getIconAnnotation?.(objectType ?? linkType)?.iconId} />
      <Link
        disabled={!path || path === "undefined"}
        onClick={() => {
          onItemClicked?.(undefined, undefined, path);
        }}
        styles={{ root: { paddingLeft: 4, ...(defaultLabelStyle as {}) } }}
      >
        {objectName}
      </Link>
    </LinkedObjectContainer>
  );
};

const LinkedObjectContainer = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default LinkedObject;
